<template>
    <div>
        <b><span>
            Precipitación actual: {{ ultima_precipitacion }} mm
        </span></b>
        <br>
        <span>
            Precipitación acumulada (A1): {{ precipitacion_acumulada }} mm
        </span>
        <br>
        <span>
            Datos recuperados: {{ datos_recuperados }}%
        </span>
        <br>
        <span>
            Última transmisión: {{ ultima_transmision }}
        </span>
        <a-tabs>
            <a-tab-pane
                key="1" 
                tab="Precipitación"
            >
                <Graph 
                    chart-title="Precipitación (últimas 24 horas)"
                    :data-series="rainfalls" 
                    :yleyend="'Precipitación (mm)'" 
                    :xleyend="leyend" 
                    :id-div="1+index"
                />
            </a-tab-pane>

            <a-tab-pane
                key="2" 
                tab="Indicador A3"
            >
                <span>
                    Datos recuperados: {{ datos_recuperados_A3 }}%
                </span>
                <Graph
                    chart-title="Indicador A3"
                    :data-series="rainfallsCalculatedA3"
                    :xleyend="leyendA3"
                    :yleyend="'Precipitación (mm)'"
                    :id-div="9+index"
                />
            </a-tab-pane>

            <a-tab-pane
                key="3" 
                tab="Indicador A25"
            >
                <span>
                    Valor máximo del indicador A25: {{ maximo_A25 }} mm
                </span>
                <br>
                <span>
                    Valor mínimo del indicador A25: {{ minimo_A25 }} mm
                </span>
                <br>
                <span>
                    Datos recuperados: {{ datos_recuperados_A25 }}%
                </span>
                <Graph
                    chart-title="Indicador A25"
                    :data-series="rainfallsCalculatedA25"
                    :xleyend="leyendA25"
                    :yleyend="'Precipitación (mm)'" 
                    :id-div="10+index"
                />
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>

    import Graph from '@/components/StationListMenu/Tabs/Graphs/Graph.vue';

    export default {
        name: "Rainfall",

        components:{
            Graph
        },

        props:{
            charts: [],
            index: Number,
            indicatorA3:[],
            indicatorA25:[]
        },

        data(){
            return{
                ultima_precipitacion: 0,
                ultima_transmision: '',
                precipitacion_acumulada: 0,
                datos_recuperados: 0,
                leyend: [],
                rainfalls: [],
                rainfallsCalculatedA3: [],
                rainfallsCalculatedA25: [],
                leyendA3: [],
                leyendA25: [],
                datos_recuperados_A3: 0,
                datos_recuperados_A25: 0,
                minimo_A25: 0,
                maximo_A25: 0,
            }
        },

        created(){
            this.Get_Rainfalls(this.charts);

            this.Get_A3(this.indicatorA3);

            this.Get_A25(this.indicatorA25);
        },

        methods:{
            /*
            * Se calculan los datos que no son nulos y se almacena su fecha y hora
            * Aquí se crea el array para constuir las series de las gráficas y el eje horizontal
            */
            Get_Rainfalls(charts){
                const datos_discretizados = [];
                const datos_acumulados = [];
                let acumulado = 0;

                for(var i in charts){
                    let precipitacion = parseFloat(charts[i].precipitation);

                    if(!isNaN(precipitacion)){
                        acumulado += precipitacion;
                        datos_discretizados.push(parseFloat(precipitacion.toFixed(1)));
                        datos_acumulados.push(parseFloat(acumulado.toFixed(1)));
                        this.leyend.push(charts[i].date+"<br/>"+charts[i].time);
                    }
                }

                this.precipitacion_acumulada = acumulado.toFixed(1);
                this.ultima_precipitacion = datos_discretizados[datos_discretizados.length-1];
                let fecha_hora = this.leyend[this.leyend.length -1];
                this.ultima_transmision = fecha_hora.replace('<br/>',' ');

                this.datos_recuperados = (datos_acumulados.length*100/charts.length).toFixed(1);

                /*
                * Estos son los datos que se envían para constuir la gráfica
                * el tipo de gráfica, el nombre de la serie, el color y los datos de las series.
                */
                this.rainfalls = [{
                    type: "area",
                    name: "Precipitación acumulada (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(76, 139, 207, 0.8)'],
                            [1, 'rgba(76, 139, 207, 0.4)']
                        ]
                    },
                    data: datos_acumulados
                },{
                    type: "column",
                    name: "Precipitación discretizada (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(0,0,0,0.8)'],
                            [1, 'rgba(0,0,0,0.4)']
                        ]
                    },
                    data: datos_discretizados
                }];
            },

            /*
            * Cálculo de precipitación últimos 3 días y mes actual
            */

            Get_A3(charts){
                const datos_discretizados = [];
                const datos_acumulados = [];
                let acumulado = 0;

                for(var i in charts){
                    let precipitacion = parseFloat(charts[i].precipitation);

                    if(!isNaN(precipitacion)){
                        acumulado += precipitacion;
                        datos_discretizados.push(parseFloat(precipitacion.toFixed(1)));
                        datos_acumulados.push(parseFloat(acumulado.toFixed(1)));
                        this.leyendA3.push(charts[i].date+"<br/>"+charts[i].time);
                    }
                }

                this.datos_recuperados_A3 = (datos_acumulados.length*100/charts.length).toFixed(1);

                this.rainfallsCalculatedA3 = [{
                    type: "area",
                    name: "Precipitación acumulada (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(76, 139, 207, 0.8)'],
                            [1, 'rgba(76, 139, 207, 0.4)']
                        ]
                    },
                    data: datos_acumulados
                },{
                    type: "column",
                    name: "Precipitación últimas 72 horas (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(0,0,0,0.8)'],
                            [1, 'rgba(0,0,0,0.4)']
                        ]
                    },
                    data: datos_discretizados
                }];
            },

            Sort_Array(x, y) {
                if (x.date < y.date) {return -1;}
                if (x.date > y.date) {return 1;}
                return 0;
            },

            Get_A25(charts){
                const datos = [];
                const datos_discretizados = [];
                const rows = charts.resultCumulativePpt.sort(this.Sort_Array);

                for(var i in rows){
                    let acumulativo = parseFloat(rows[i].cumulativePpt);
                    let discretizada = parseFloat(rows[i].precipitation);
                    if(!isNaN(acumulativo)){
                        datos.push(parseFloat(acumulativo.toFixed(1)));
                        datos_discretizados.push(parseFloat(discretizada.toFixed(1)));
                        this.leyendA25.push(rows[i].date);
                    }
                }

                this.maximo_A25 = charts.maxPpt.toFixed(1);
                this.minimo_A25 = charts.minPpt.toFixed(1);
                this.datos_recuperados_A25 = (datos.length*100/charts.resultCumulativePpt.length).toFixed(1);

                this.rainfallsCalculatedA25 = [{
                    type: "area",
                    name: "Indicador A25 (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(76, 139, 207, 0.8)'],
                            [1, 'rgba(76, 139, 207, 0.4)']
                        ]
                    },
                    data: datos
                },{
                    type: "column",
                    name: "Precipitación acumulada diaria (mm)",
                    color: {
                        linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                        stops: [
                            [0, 'rgba(0,0,0,0.8)'],
                            [1, 'rgba(0,0,0,0.4)']
                        ]
                    },
                    data: datos_discretizados
                }];
            }
        }
    };
</script>